"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertProvider = exports.AlertHandler = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const useAlert_1 = require("./useAlert");
const Alert_1 = require("./Alert");
const alert_context_1 = require("./alert.context");
const AlertHandler = ({ children }) => {
    const { removeAlert, alertList } = (0, useAlert_1.useAlert)();
    const handleAlertClose = (alert) => {
        removeAlert(alert);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { style: {
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 30,
                    display: 'flex',
                    alignItems: 'flex-end',
                    justifyContent: 'center',
                    pointerEvents: 'none'
                }, children: (0, jsx_runtime_1.jsx)("div", { className: "p-3", children: alertList && alertList.map((alert) => ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Alert_1.Alert, { data: alert, onClose: () => {
                                handleAlertClose(alert);
                            } }) }, alert.id))) }) }), children] }));
};
exports.AlertHandler = AlertHandler;
const AlertProvider = ({ children }) => {
    return ((0, jsx_runtime_1.jsx)(alert_context_1.AlertContextProvider, { children: (0, jsx_runtime_1.jsx)(exports.AlertHandler, { children: children }) }));
};
exports.AlertProvider = AlertProvider;
